import AppMenuItem from "./AppMenuItem";

export default AppMenuItem;
export type { AppMenuItemProps } from "./AppMenuItem";
